import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const Product = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const { invalidateApi } = useGlobalAPIQueryContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [category, setCategory] = useState([]);

    const { useFetch: useFetchGeneric } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData, isLoading: genericDataLoading } =
        useFetchGeneric({
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        });

    const { useFetch } = useAPIQuery({
        key: "item",
        endpoint: "/api/item/",
    });

    const { data, isFetching } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "item",
        endpoint: "/api/item/",
    });

    const columns = [
        {
            accessor: "item_name",
            header: "Item Name",
            cell: (row) => <>{row?.item_name ? row?.item_name : "-"}</>,
        },
        {
            accessor: "item_code",
            header: "Item Code",
            cell: (row) => <>{row?.item_code ? row?.item_code : "-"}</>,
        },
        {
            accessor: "category",
            header: "Category",
            filterable: true,
            filterType: "dropdown",
            filterOpt: category
                ? category?.map((api) => {
                      return {
                          label: api.name,
                          value: api.name,
                      };
                  })
                : [],
        },
        {
            accessor: "threshold_amount",
            header: "Threshold Amount",
        },
        {
            accessor: "stock_quantity",
            header: "Stock Quantity",
            cell: (row) => <>{row?.stock_quantity}</>,
        },
        {
            accessor: "lead_time",
            header: "Lead Time",
        },
        {
            accessor: "procurement_type",
            header: "Procurement Type",
            cell: (row) => (
                <>{row?.procurement_type ? row?.procurement_type : "-"}</>
            ),
        },
    ];

    console.log(data);

    const { mutate: deleteData } = useDelete({
        onSuccess: () => {
            invalidateApi({ key: ["api/generic"] });
        },
    });

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-item", { state: { editpost: row.original } });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    useEffect(() => {
        if (genericData) {
            setCategory(
                genericData?.typemaster?.filter(
                    (post) => post.category_value == "item_category"
                )
            );
        }
    }, [genericData]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">Item</h3>
                    </div>
                    {privileges.includes("item_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-item"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-product"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-item"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-product"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Item</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data.count : 0}
                globalSearch
                editRows={privileges.includes("item_update") ? true : false}
                deleteRows={privileges.includes("item_delete") ? true : false}
                filterModal={false}
                selectRows={false}
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                isLoading={isFetching}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default Product;
